// create a container and set the full-size image as its background
function createOverlay(image) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${image.src}`);
  overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
  };

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading__spinner`);
  loadingSpinner.classList.toggle('hidden');
}

function moveWithHover(image, event, zoomRatio) {
  // calculate mouse position
  const ratio = image.height / image.width;
  const container = event.target.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  // determine what to show in the frame
  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function magnify(image, zoomRatio) {
  const overlay = createOverlay(image);
  overlay.onclick = () => overlay.remove();
  overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
  overlay.onmouseleave = () => overlay.remove();
  return overlay;
}

// Illusiv: magnify on hover (Threadless-style) for mouse users; click opens the lightbox.
// Touch / coarse-pointer devices keep the original tap-to-magnify behaviour.
function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');
  const hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  images.forEach((image) => {
    if (image.dataset.magnifyBound) return;
    image.dataset.magnifyBound = 'true';

    if (!hoverCapable) {
      image.onclick = (event) => {
        magnify(image, zoomRatio);
        moveWithHover(image, event, zoomRatio);
      };
      return;
    }

    const container = image.parentElement; // .product__media — the overlay is inserted here
    let overlay = null;
    let hovering = false;

    const openLightbox = () => {
      const button = image.closest('modal-opener')?.querySelector('.product__media-toggle');
      if (button) button.click();
    };

    const removeOverlay = () => {
      if (overlay) overlay.remove();
      overlay = null;
    };

    container.addEventListener('mouseenter', (event) => {
      hovering = true;
      if (overlay) return;
      overlay = createOverlay(image);
      overlay.onmousemove = (e) => moveWithHover(image, e, zoomRatio);
      overlay.onclick = () => {
        removeOverlay();
        openLightbox();
      };
      // createOverlay inserts the frame once the full image has loaded; drop it if the mouse already left
      const check = setInterval(() => {
        if (!overlay) { clearInterval(check); return; }
        if (overlay.isConnected) {
          clearInterval(check);
          if (!hovering) removeOverlay();
        }
      }, 50);
      moveWithHover(image, event, zoomRatio);
    });

    container.addEventListener('mouseleave', () => {
      hovering = false;
      removeOverlay();
    });

    // Plain click on the image (before the overlay is up) also opens the lightbox
    image.onclick = (event) => {
      event.preventDefault();
      openLightbox();
    };
  });
}

enableZoomOnHover(2.2);
// Media can be re-rendered on variant change; bind any new images too (debounced)
let magnifyRebind = null;
new MutationObserver(() => {
  clearTimeout(magnifyRebind);
  magnifyRebind = setTimeout(() => enableZoomOnHover(2.2), 150);
}).observe(document.body, { childList: true, subtree: true });
